// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const DeleteIntents = () => {

   const [json, set_json] = React.useState();
   const [kill, set_kill] = React.useState([]);
   const [rows, set_rows] = React.useState();

   var content   = [];

   var key_index = 1;

   const begin = async ({ set_form, set_warn, ...args }) => {
      // The begin() function initiates an API call to get information required to build the form. If no
      // information is needed then you can omit the begin() function or just set the form state to BUILD;
      var response = await api.fetch('dbs/source/list/' + app.state.user_access_list[app.state.user_access_id].version_id, api.token());
      if (!response.good) {
         set_warn('undefined' === typeof response.data.text ? 'Unrecognized API errror.' : response.data.text);
      } else {
         set_json(response.data);
      }
      set_form(FORM.BUILD);
   } // begin();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      content.push(
         <tr key={key_index++}>
           <td key={key_index++}>Id</td>
           <td key={key_index++}>Type</td>
           <td key={key_index++}>Details</td>
         </tr>
      );

      if (json && json.source_list) {
         const list = json.source_list;
         for (var ith = 0; ith < list.length; ith++) {
            content.push(
               <tr key={key_index++}>
                 <td key={key_index++}>
                   <input className="ask-henry-checkbox" data-id={ith} key={key_index++} type="checkbox" /> {list[ith].source_id}
                 </td>
                 <td key={key_index++}>{list[ith].type}</td>
                 <td key={key_index++}>{list[ith].details}</td>
               </tr>
            );
         }
      }

      set_body(
         <>
           {warn}
           <button className="ask-henry-form-button" onClick={(e) => build_check(e, true)} >Check All</button>
           <button className="ask-henry-form-button" onClick={(e) => build_check(e, false)} >Clear All</button>
           <div className="ask-henry-form-delete-source-scroll" key={key_index++}>
             <table className="ask-henry-data-grid" key={key_index++}>
               <tbody>
               {content}
               </tbody>
             </table>
           </div>
         </>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Close</button>
         </>
      );

   } // build();

   const build_check = (event, state) => {
      event.preventDefault();
      const list = document.getElementsByClassName('ask-henry-checkbox');
      for (var ith = 0; ith < list.length; ith++) {
         list[ith].checked = state;
      }
   } // build_check();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;
      const list = document.getElementsByClassName('ask-henry-checkbox');
      const kill = [];
      for (var ith = 0; ith < list.length; ith++) {
         if (list[ith].checked) kill.push(ith);
      }
      set_kill(kill);
      if (!kill.length) {
         set_warn('Select at least one intent before you click the Submit button:');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }
   } // check();

   const enact = async ({ set_body, set_foot, set_form, set_pass, set_warn, pass, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      set_warn('');

      var index     = kill[pass-1];

      var source_id = json.source_list[index].source_id;

      var response  = await api.fetch('dbs/source/delete/' + app.state.user_access_list[app.state.user_access_id].version_id + '/' + source_id, api.token());

      var status    = 'Deleted';

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            status = 'Unrecognized error returned from API.';
         } else {
            status = response.data.text;
         }
         set_warn(status);
      } 

      if (pass < kill.length) {
         set_pass(pass + 1);
         set_foot(<button className="ask-henry-form-button" onClick={form_close} >Cancel</button>);
      } else {
         set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
      }

      var info =
         <>
           {rows}
           <tr>
             <td>{source_id}</td>
             <td>{json.source_list[index].details}</td>
             <td>{status}</td>
           </tr>
         </>
      ;

      set_rows(info);

      set_body(
         <div className="ask-henry-form-delete-source-scroll">
           <table className="ask-henry-data-grid">
             <tbody>
               <tr>
                 <td>Id</td>
                 <td>Details</td>
                 <td>Status</td>
               </tr>
               {info}
             </tbody>
           </table>
        </div>
      );

      app.set_state('status', 'Deleted intent ' + json.source_list[index].details);

   } // enact();

   return <Form begin={begin} build={build} check={check} class_string="ask-henry-form-delete-source" enact={enact} title={'Delete Intents' + app.who()} />

} // <DeleteIntents />;

export default DeleteIntents;
